"use strict";

module.exports = angular.module(__filename, [
    require('data/filters-partition.srv').name,
    require('./filter-mold-service').name
]).factory("ChannelsMold", ['filtersPartition', 'filterMoldService', function (filtersPartition, filterMoldService) {
    return function ChannelsMold() {
        this._value = [{label: "Web", value: "articles"}];
        this.default = [];
        filterMoldService.getDefaultFilterMoldFunction.call(this, filtersPartition.channel);
    }
}]);
